import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhone = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M26.444 20.19v3.746a2.494 2.494 0 01-1.701 2.377c-.33.111-.68.153-1.027.121a24.796 24.796 0 01-10.8-3.834 24.378 24.378 0 01-7.508-7.494A24.685 24.685 0 011.566 4.279a2.493 2.493 0 011.481-2.51c.318-.14.662-.212 1.01-.212H7.81a2.506 2.506 0 012.503 2.148c.159 1.199.452 2.376.876 3.51a2.493 2.493 0 01-.563 2.635l-1.59 1.586a20.003 20.003 0 007.51 7.493l1.588-1.586a2.504 2.504 0 012.64-.562c1.136.423 2.316.716 3.517.874a2.504 2.504 0 012.153 2.536z",
		stroke: "#fff",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPhone;
